module.exports = __webpack_public_path__ + "img/top-reason-ai.559d213f.png";